import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { useContent } from "../../context/ContentContext";

export default function About() {
  const { t, pick } = useLang();
  const { content } = useContent();
  if (!content) return null;
  const stats = content.stats || [];

  return (
    <section id="about" className="relative py-24 md:py-32 px-5 md:px-10 border-t border-white/10" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-7">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-acid mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-acid" /> {t("about_kicker")}
          </p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-display uppercase text-4xl md:text-6xl leading-[0.9] text-white max-w-2xl"
          >
            {pick(content.about, "heading")}
          </motion.h2>
          <p className="mt-8 text-silver text-base md:text-lg leading-relaxed max-w-xl">
            {pick(content.about, "body")}
          </p>
        </div>

        <div className="lg:col-span-5 grid grid-cols-2 gap-px bg-white/10 border border-white/10 self-start">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-obsidian p-8 flex flex-col gap-2"
              data-testid={`stat-${i}`}
            >
              <span className="font-display text-4xl md:text-5xl text-acid">{s.value}</span>
              <span className="font-mono text-xs uppercase tracking-wide text-silver">{pick(s, "label")}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
